module.exports = __webpack_public_path__ + "img/sad--pressed.0f4c110c.svg";